/**
Project: Voice Panel (c)
Title: App Page Title.
Description: Component for App page Title Browser. 
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/

import React from 'react';
import { Helmet } from 'react-helmet-async';
import PageUtil from "../helpers/page-util";

const AppPageTitle = ({ pageTitle }) => {
    return (
        <Helmet>
            <title>{PageUtil.getHeadTitle(pageTitle)}</title>
        </Helmet>
    );
};

export { AppPageTitle };